import LegalPage from "../components/LegalPage";
import { REFERRAL_TERMS_SECTIONS, GALLERY } from "../data/content";

const ReferralTerms = () => (
  <LegalPage
    testId="referral-terms-page"
    path="/referral-terms"
    seoTitle="Refer-a-Friend Scheme Terms"
    seoDescription="The rules of the BTK Mortgage Services refer-a-friend scheme — £100 John Lewis or Amazon voucher when a referred mortgage completes with us."
    eyebrow="Legal · Refer a Friend"
    title="Refer a friend —"
    italic="scheme terms."
    intro="The rules behind the £100 John Lewis or Amazon voucher. Short, fair and honest."
    image={GALLERY[5]}
    sections={REFERRAL_TERMS_SECTIONS}
  />
);

export default ReferralTerms;
